"use client";

import { useField } from "formik";
import { cn } from "@/lib/utils";
import type { TextareaHTMLAttributes } from "react";

export interface TextAreaFieldProps
	extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label: string;
	name: string;
}

export function TextAreaField({
	label,
	className,
	rows = 4,
	...props
}: TextAreaFieldProps) {
	const [field, meta] = useField(props.name);
	const hasError = Boolean(meta.touched && meta.error);

	return (
		<label className="form-control w-full">
			<div className="label">
				<span className="label-text font-semibold">{label}</span>
			</div>
			<textarea
				{...field}
				{...props}
				rows={rows}
				className={cn(
					"textarea textarea-bordered w-full border",
					className,
					hasError && "textarea-error"
				)}
			/>
			<div className="label">
				{hasError ? (
					<span className="label-text-alt text-error">
						{meta.error}
					</span>
				) : null}
			</div>
		</label>
	);
}
